import { useMemo } from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import type { NavigationItem } from '@af/design-system-docs-ui/navigation/types';

import { navigation } from './navigation';
import { resolveNavigationStatuses, type PackageStatuses } from './resolve-navigation-statuses';

/**
 * Supplies package release phases to the otherwise static sidebar definition.
 */
export function useNavigation(): NavigationItem[] {
	const data = useStaticQuery<{
		allWorkspaceInfo: { nodes: PackageStatuses[] };
	}>(graphql`
		query SidebarReleaseStatuses {
			allWorkspaceInfo {
				nodes {
					slug
					status
					pages
					subPages
				}
			}
		}
	`);
	return useMemo(() => resolveNavigationStatuses(navigation, data.allWorkspaceInfo.nodes), [data]);
}
